
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "createQaEvaluation",
      resolverType: "mutation",
      routePath: "/createQaEvaluation",
      httpMethod: "POST",
    });
  